<h1 matDialogTitle>{{ data.title }}</h1>
<mat-dialog-content>
  <p class="color-primary">{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end"
  ><br />
  <button mat-button color="primary" mat-dialog-close cdkFocusInitial>{{ data.button || 'OK' }}</button>
</mat-dialog-actions>
